import {
  FabricAnnotationAnimationType,
  FabricAnnotationType,
  FabricMapErrorCode,
  FabricMapNaviType,
  FabricMapPathType,
  MapDistanceSearchType,
  MAPinAnnotationColor,
  MapSupplierType,
} from './constants/index.js';
import { type FabricSetMapCarApi, setMapCar } from './map-car.js';
import { type FabricMapSubscribeEventApi, subscribe } from './map-event.js';
import {
  type FabricMapSetHotRegionApi,
  setHotRegion,
} from './map-hot-region.js';
import { getLocation, type MapLocationGetLocationApi } from './map-location.js';
import { type FabricMapStartApi, startMap } from './map-main.js';
import {
  type FabricSetMapPathPlanningApi,
  setMapPathPlanning,
} from './map-path-planning.js';
import { type FabricSearchMapApi, searchMap } from './map-search.js';
import { type FabricMapApi, setMap } from './map-set.js';

type ConstantsType = {
  /**
   * 标柱的动画效果配置
   */
  annotationAnimationType: typeof FabricAnnotationAnimationType;
  /**
   * (地图内置, 需要传递 `pinColor`),点标注 \大头针标注、 地图内置 \ 动画标注
   */
  annotationType: typeof FabricAnnotationType;
  /**
   * 地图操作常用错误状态码定义
   */
  mapErrorCode: typeof FabricMapErrorCode;
  /**
   * 步行/驾车/打车
   */
  mapNaviType: typeof FabricMapNaviType;
  /**
   * 路径规划, 单路径, 还是多路径
   */
  mapPathType: typeof FabricMapPathType;
  /**
   * 地图厂商坐标类型枚举, 百度, 高德, 腾讯, google....
   */
  mapSupplierType: typeof MapSupplierType;
  /**
   * 距离测量类型
   */
  distanceSearchType: typeof MapDistanceSearchType;
  /**
   * 高德地图 pinColor 内置大头针的枚举
   */
  mapInAnnotationColor: typeof MAPinAnnotationColor;
};

const constants: ConstantsType = {
  annotationAnimationType: FabricAnnotationAnimationType,
  annotationType: FabricAnnotationType,
  mapErrorCode: FabricMapErrorCode,
  mapNaviType: FabricMapNaviType,
  mapPathType: FabricMapPathType,
  mapSupplierType: MapSupplierType,
  distanceSearchType: MapDistanceSearchType,
  mapInAnnotationColor: MAPinAnnotationColor,
};

export type FabricMapExportApi = {
  /**
   * 启动打车插件.
   */
  startMap: FabricMapStartApi;
  /**
   * 传输时间热区位置点, 到Native, 当前热区只支持矩形, 坐标原点为左上角定点.
   */
  setHotRegion: FabricMapSetHotRegionApi;
  /**
   * 设置地图各种API
   */
  setMap: FabricMapApi;
  /**
   * 打车路径规划中的小车配置
   */
  setMapCar: FabricSetMapCarApi;
  /**
   * 设置地图行车路径规划
   */
  setMapPathPlanning: FabricSetMapPathPlanningApi;
  /**
   * 通过地址搜索位置.
   */
  searchMap: FabricSearchMapApi;
  /**
   * 注注册回调事件接受Native主动通知H5的各种事件.
   */
  subscribe: FabricMapSubscribeEventApi;
  /**
   * 获取当前的地理位置、速度。开启高精度定位，接口耗时会增加，可指定 expireTime 作为超时时间
   * 1. 如果定位被用户强制关闭, 或者用户点了拒绝, 或者在设置里面禁用了, 返回错误code:`location_permission_disallow`
   * 2. 如果定位超时了, 则返回错误code: `location_service_timeout`
   * 3. 如果定位未决定, 则返回错误code: `location_service_not_determined`(iOS可能弹出来用户很久未点, 会自动抛出系统BUG)
   */
  getLocation: MapLocationGetLocationApi;
  /**
   * 常用的枚举常量
   */
  constants: ConstantsType;
};

/**
 * Fabric打车插件.
 */
export const fabricMap: FabricMapExportApi = {
  startMap,
  subscribe,
  setMap,
  setHotRegion,
  setMapCar,
  setMapPathPlanning,
  searchMap,
  getLocation,
  constants,
};
